import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import MultiLines from './MultiLines';
import {Tools} from './Tools';
import {Exam} from './Inc';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import useStyles from './Styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';

interface FirstConfirmProps {
    exam:Exam,
	isOpen:boolean,
    send():void,
    close(): void,
}

const FirstConfirm: React.FC<FirstConfirmProps> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			fullScreen={fullScreen}
		>
			<DialogTitle color='primary'>事前審査</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					この内容でよろしいですか？<br/>
					よろしかったら「送信する」を押して下さい。<br/>
				</div>
				<div style={{marginBottom:"2em"}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>お名前</FormLabel>
								<div className={classes.formValue}>{Tools.stripTags(props.exam.name)}</div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>お名前（カナ）</FormLabel>
								<div className={classes.formValue}>{Tools.stripTags(props.exam.kana)}</div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>作家名・サークル名</FormLabel>
								<div className={classes.formValue}>{Tools.empty(Tools.stripTags(props.exam.group))}</div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>メールアドレス</FormLabel>
								<div className={classes.formValue}>{Tools.stripTags(props.exam.mail)}</div>
							</FormControl>
						</Grid>
					</Grid>
				</div>
				<div className={classes.section}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={12}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>作品のジャンル</FormLabel>
								<div className={classes.formValue}>{props.exam.cat}</div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>作品の詳細</FormLabel>
								<div className={classes.formValue}><MultiLines text={props.exam.text1} empty={true} name="text1"/></div>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={6}>
							<FormControl className={classes.formControl} fullWidth={true} required={false}>
								<FormLabel component="label" className={classes.formLabel}>その他の作品</FormLabel>
								<div className={classes.formValue}><MultiLines text={props.exam.text2} empty={true} name="text2"/></div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl className={classes.formControl} fullWidth={true} required={false}>
								<FormLabel component="label" className={classes.formLabel}>活動について</FormLabel>
								<div className={classes.formValue}><MultiLines text={props.exam.text3} empty={true} name="text3"/></div>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12}>
							<FormControl className={classes.formControl} fullWidth={true}>
								<FormLabel component="label" className={classes.formLabel}>ブログやサイトのURL</FormLabel>
								<div className={classes.formValue}>{Tools.empty(Tools.stripTags(props.exam.url))}</div>
							</FormControl>
						</Grid>
					</Grid>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='送信する' onClick1={props.send} button2="やりなおし" onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default FirstConfirm;
